import { useAuth0 } from "@auth0/auth0-react";
import { useMutation } from '@tanstack/react-query';
import { getHeaders } from "../../../helpers/helper";
import axiosInstance from "../../../shared/config/axiosInstance";

async function updateProducts(data: any, getAccessTokenSilently: any): Promise<any> {
  const headers = await getHeaders(getAccessTokenSilently);
  
  const response = await axiosInstance.post('/admin/SetProducts', data, {
    headers
  });
  
  return response.data;
}

export const useUpdateProducts = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useMutation({
    mutationFn: (data: any) => updateProducts(data, getAccessTokenSilently),
  });
};